<template>
  <div class="info-client--container no-select">
    <ul class="tabs-container">
      <li
        @click="clickTab(item)"
        v-bind:class="{ active: item.isActive }"
        v-for="item in tabs"
        :key="item.id"
      >
        {{ item.name }}
      </li>
    </ul>
    <edit-client
      v-if="activeTabIndex == 1 && show === true"
      :reset="show"
      :id="id"
      :noUpdate="noUpdate"
      :noDelete="noDelete"
      @editClient="editClient"
      @deleteClient="deleteClient"
    ></edit-client>
    <statistic-client v-if="activeTabIndex == 2" :id="id"></statistic-client>
    <history-client v-if="activeTabIndex == 3" :id="id"></history-client>
    <relations-client v-if="activeTabIndex == 4" :id="id"></relations-client>
  </div>
</template>

<script>

import EditClient from "@/components/panel/clients/EditClient";
import StatisticClient from "@/components/panel/clients/StatisticClient";
import HistoryClient from "@/components/panel/clients/HistoryClient";
import RelationsClient from './RelationsClient.vue';
export default {
  name: "InfoClient",
  components: {HistoryClient, StatisticClient, EditClient, RelationsClient },
  data() {
    return {
      tabs: [
        {
          id: 1,
          name: "Данные",
          isActive: true
        },
        {
          id: 2,
          name: "Статистика",
          isActive: false
        },
        {
          id: 3,
          name: "История записей",
          isActive: false
        },
        {
          id: 4,
          name: "Связи",
          isActive: false
        },
      ]
    };
  },
  props: {
    id: Number, // ID клиента для загрузки информации
    noUpdate: Boolean, // true - запретить изменение клиента
    noDelete: Boolean, // true - запретить удаление клиента
    show: Boolean
  },
  watch: {},
  computed: {
    activeTabIndex() {
      let result = 0;
      this.tabs.forEach(function(item) {
        if (item.isActive) {
          result = item.id;
        }
      });
      return result;
    }
  },
  methods: {
    clickTab(item) {
      for (let key in this.tabs) {
        if (this.tabs[key].id === item.id) {
          this.tabs[key].isActive = true;
        } else {
          this.tabs[key].isActive = false;
        }
      }
    },
    editClient(val) {
      this.$emit("updateClient", val);
    },
    deleteClient(){
      this.$emit('deleteClient');
    }
  },
  created() {}
};
</script>

<style scoped lang="less"></style>
